<template>
    <div>
        <transition-group name="fade">
            <div v-if="loaded && Object.keys(shippingMethods).length" key="shippingMethods">
                <h2 class="h5">{{ t.checkout.shipping_method }}</h2>
                <div class="row">
                    <div v-for="shippingMethod in shippingMethods" :key="shippingMethod.code" class="col-md-2 d-flex mb-3">
                        <div class="btn text-center p-2 d-flex flex-column align-items-center justify-content-center w-100 tooltip-css"
                            :class="{
                                    'bg-white border': shippingMethod.enabled && selectedShippingMethod != shippingMethod.code,
                                    'btn-primary': shippingMethod.enabled && selectedShippingMethod == shippingMethod.code,
                                    'btn-light cursor-no-drop text-': !shippingMethod.enabled
                                }"
                            @click="selectShippingMethod(shippingMethod)">
                            {{ shippingMethod.name }}
                            <div v-if="shippingMethod.rate">({{ amountWithCurrency(shippingMethod.rate) }})</div> <span
                                v-if="shippingMethod.message" class="tooltip-text right">{{ shippingMethod.message }}</span>
                        </div>
                    </div>
                </div>
                <button v-if="!selectedShippingMethod" class="btn btn-secondary" type="button" @click="$listeners.back()">{{
                    t.global.back }}</button>
            </div>
            <div v-if="loaded
                && ((selectedShippingMethod && ['FEDEX', 'TCAT', 'TCAT_OI', 'POST'].includes(selectedShippingMethod))
                    || !Object.keys(shippingMethods).length)" key="shippingInfo">
                <transition-group name="fade">
                    <div v-if="showAddressesComponent" key="addresses_component">
                        <div class="h5" v-if="loaded && Object.keys(shippingMethods).length">{{ t.shipping_details.shipping_address }}</div>
                        <!-- v-bind="this.$data" -->
                        <addresses-component
                        v-bind="{ context: 'checkout', user: user }"
                        v-on:goToNextStep="goToNextStep"
                        v-on:back="back"
                        v-on:saveShippingDetails="saveShippingDetails"></addresses-component>

                    </div>
                    <div v-if="showFedexServices" key="fedexServices" class="mt-3">
                        <h2 class="h5">{{ t.checkout.shipping_service }}</h2>
                        <div v-if="fedexShippingServices.length">
                            <form @submit.prevent="saveFedexShippingService"
                                @keydown="formFedexShippingService.onKeydown($event)">
                                <div v-for="shippingService in fedexShippingServices" :key="shippingService.name">
                                    <label :for="shippingService.code" class="fw-normal cursor-pointer">
                                        <input v-model="formFedexShippingService.service"
                                            :value="{ 'provider': shippingService.provider, 'code': shippingService.code }"
                                            type="radio" :id="shippingService.code" class="me-2">
                                        {{ shippingService.name }} <b>{{ amountWithCurrency(shippingService.rate) }}</b>
                                        <small>({{ t.checkout.delivery_date }}: {{ shippingService.delivery_date }})</small>
                                    </label>
                                </div>
                                <div class="small text-danger" v-if="formFedexShippingService.errors.has('service')"
                                    v-html="formFedexShippingService.errors.get('service')" ></div>
                                <div class="mt-3">
                                    <button class="btn btn-secondary me-2" type="button"
                                        :disabled="formFedexShippingService.busy" @click="$listeners.back()">{{
                                            t.global.back }}</button>
                                    <button class="btn btn-primary" type="submit"
                                        :disabled="formFedexShippingService.busy">{{ t.checkout.next_step }}</button>
                                </div>
                            </form>
                        </div>
                        <div v-else class="alert alert-danger">{{ t.checkout.general_error }}</div>
                    </div>
                </transition-group>
            </div>
        </transition-group>
    </div>
</template>

<script>
import Form from 'vform'
export default {
    data() {
        return Object.assign({
            loaded: false,
            shippingMethods: {},
            selectedShippingMethod: null,
            formShippingInfo: new Form(),
            formFedexShippingService: new Form({
                service: this.loaded ? this.cart.shipping_data.service : null,
            }),
            showAddressesComponent: true,
            showFedexServices: false,
            fedexShippingServices: [],
        }, this.$attrs)
    },
    mounted() {
        this.getShippingMethods();
    },
    methods: {
        getShippingMethods() {
            this.selectedShippingMethod = null
            axios
                .get("/ajax/checkout/shipping-methods")
                .catch((error) => { Vue.notify({ text: error.message, type: 'error' }) })
                .then((response) => {
                    this.shippingMethods = response.data
                    this.loaded = true
                });
        },
        selectShippingMethod(shippingMethod) {
            if (shippingMethod.enabled) {
                if (shippingMethod.type == 'CVS') {
                    window.location.replace(shippingMethod.url)
                } else { // HOME
                    this.selectedShippingMethod = shippingMethod.code
                }
            }
        },
        goToNextStep() {
            this.$listeners.goToNextStep()
        },
        back() {
            this.$listeners.back()
        },
        async saveShippingDetails(address = null) {
            this.formShippingInfo.update({ 'shipping_method': this.selectedShippingMethod })
            if (address) {
                this.formShippingInfo.update({ 'address': address })
            }
            const response = await this.formShippingInfo.post('ajax/checkout/shipping-details')
            if (response.data.success) {
                if (this.config.shipping_providers.length) {
                    switch (this.selectedShippingMethod) {
                        case 'FEDEX':
                            if (response.data.shipping_services.success) {
                                this.showFedexServices = true
                                this.fedexShippingServices = response.data.shipping_services.services
                            } else {
                                Vue.notify({ text: response.data.shipping_services.message, type: 'error' })
                            }
                            break;
                        case 'TCAT':
                        case 'TCAT_OI':
                        case 'POST':
                            EventBus.$emit('cart-changed')
                            this.$listeners.goToNextStep()
                            break;
                    }
                } else {
                    this.$listeners.goToNextStep()
                }
            } else {
                Vue.notify({ text: response.data.message, type: 'error' })
            }
        },
        async saveFedexShippingService() {
            const response = await this.formFedexShippingService.post(this.url('ajax/checkout/fedex-shipping-service'))
            if (response.data.success) {
                this.formFedexShippingService = new Form(response.data.values)
                EventBus.$emit('cart-changed')
                this.$listeners.goToNextStep()
            } else {
                Vue.notify({ text: response.data.message, type: 'error' })
            }
        },
    },
    created() {
        EventBus.$on('cart-changed', () => {
            this.getShippingMethods()
        });
    },
}
</script>
